import React, { useEffect } from 'react';
import '../styles/dialog.css';
import PendingInvitesList from './PendingInvitesList';

export default function PendingInvitesDialog({ open, onClose, companyData }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (e.target.classList.contains('modal-backdrop')) onClose?.();
      }}
    >
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pending-invites-title"
      >
        <div className="modal-header">
          <div className="modal-title" id="pending-invites-title">
            Pending Invites
          </div>
        </div>
        <div className="modal-body">
          <PendingInvitesList companyData={companyData} isActive={open} />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
